import React from 'react';
import { BrandColor } from '@styleseat/brand';

export type InfoIconProps = {
  width?: number | string;
  height?: number | string;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export function InfoIcon({
  width = 14,
  height = 14,
  color = BrandColor.Metal,
}: InfoIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.666664 8C0.666664 12.0501 3.94991 15.3333 8 15.3333C12.0501 15.3333 15.3333 12.0501 15.3333 8C15.3333 3.94992 12.0501 0.666672 8 0.666672C3.94991 0.666672 0.666664 3.94992 0.666664 8ZM14 8.00001C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8.00001C2 4.6863 4.68629 2.00001 8 2.00001C11.3137 2.00001 14 4.6863 14 8.00001ZM8.66907 9.33224H9.3353V10.6656H6.66863V9.33224H7.3353V7.9989H6.66863V6.66557H8.66907V9.33224ZM8.6671 5.33224C8.6671 5.70043 8.36853 5.9989 8.00022 5.9989C7.63191 5.9989 7.33333 5.70043 7.33333 5.33224C7.33333 4.96405 7.63191 4.66557 8.00022 4.66557C8.36853 4.66557 8.6671 4.96405 8.6671 5.33224Z"
        fill="#494948"
      />
    </svg>
  );
}
